export enum ScheduleCategoryLinkTypes {
  academicSemester = 1,
  academicYear = 2,
  custom = 3
}
